import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import './index.less';
import '../../styles.less';
import { Input, Button, Modal, Form, message, Radio, Tooltip } from 'antd';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { arrayMoveImmutable } from 'array-move';
import ActivitiesComponent from './components/Activities';
import ContentComponent from './components/Contents';
import SolutionsComponent from './components/Solutions';
import DetailsComponent from './components/Details';
import FreesComponent from './components/Frees';
import TrainingComponent from './components/Training';
import TinymceEditor from './components/TinymceEditor';
import { isEffectivelyEmptyRichHtml } from '@components/common/RichEditor';
import SortableModuleRow from './SortableModuleRow';
import PageHeader from '@components/PageHeader/PageHeader';
import { useProjectContext } from '@/contexts/ProjectContext';
import { WORKSPACE_PARENT_PATH, WORKSPACE_ROUTE_BASE } from '@/layouts/workspaceConfig';

import useSortDragUserSelectChrome from '../../hooks/useSortDragUserSelectChrome';
import { moduleListApi, moduleSortApi, moduleSaveApi, moduleUpdateApi, moduleDeleteApi } from '@services/MedProject';
import { workspaceMedProjectMembersPath, workspaceMedProjectModulesPath } from '@/layouts/medProjectWorkspacePaths';
export default function RelatedProjectList() {
    const navigate = useNavigate();
    const { id: projectContextId, name: projectName } = useProjectContext();

    const params = useParams();
    const id = (params?.id && Number(params?.id)) || 0;
    const projectId = params?.projectId || 0; // 项目id
    // const projectId = 692;
    console.log(id);

    useEffect(() => {
        document.title = '模块管理-医项目';
    }, []);

    const [form] = Form.useForm();

    const [modalTitle, setModalTitle] = useState('添加模块');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [menuList, setMenuList] = useState([]);
    const [menuTitle, setMenuTitle] = useState('');
    const [editorContents, setEditorContents] = useState('');
    const [initEditorValue, setInitEditorValue] = useState(null);
    const [currentModule, setCurrentModule] = useState(null);
    const [radioVal, setRadioVal] = useState('link'); // link-外链，rich_text-图文, time_line-时间轴
    const [radioHotVal, setRadioHotVal] = useState(0); // 1-显示，0-隐藏
    const [radioTabVal, setRadioTabVal] = useState(0); // 1-显示，0-隐藏

    const [sideCollapsed, setSideCollapsed] = useState(false);

    const [components, setComponents] = useState(<ActivitiesComponent />);

    // 切换模块
    const changeModules = item => {
        if (item.moduleType !== 'member') {
            navigate(workspaceMedProjectModulesPath(projectId, item.id));
            setComponents(getComponent(item.moduleType));
        } else {
            navigate(workspaceMedProjectMembersPath(projectId));
        }
    };

    const handleOk = () => {
        form.validateFields().then(async values => {
            if (menuTitle) {
                const reqParams = {
                    ...values,
                    id: currentModule.id,
                    moduleType: currentModule.moduleType,
                    projectId,
                    url: currentModule.url,
                    content: currentModule.content,
                };
                const res = await moduleUpdateApi(reqParams);
                if (res && res.status_code === 200) {
                    message.success('保存成功');
                    setIsModalOpen(false);
                    getModules();
                    form.resetFields();
                }
            } else {
                const reqParams = {
                    ...values,
                    projectId,
                };
                const res = await moduleSaveApi(reqParams);
                if (res && res.status_code === 200) {
                    message.success('保存成功');
                    setIsModalOpen(false);
                    getModules();
                    form.resetFields();
                }
            }
        });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const radioChange = e => {
        console.log('radio: ', e);
        setRadioVal(e.target.value);
    };
    const radioHotChange = e => {
        console.log('radio: ', e);
        setRadioHotVal(e.target.value);
    };
    const radioTabChange = e => {
        console.log('radio: ', e);
        setRadioTabVal(e.target.value);
    };

    // 添加模块
    const addModule = () => {
        setModalTitle('添加模块');
        setIsModalOpen(true);
        setMenuTitle('');
        setEditorContents('');
        setInitEditorValue(null);
        setRadioVal('link');
        form.setFieldValue('isShowHot', 0);
        form.setFieldValue('isShowTab', 1);
    };

    // 编辑模块
    const editModule = async (e, item) => {
        // console.log(item)
        e.stopPropagation();
        setModalTitle('修改名称');
        setIsModalOpen(true);
        form.setFieldValue('name', item.name);
        setMenuTitle(item.name);
        setEditorContents('');
        setInitEditorValue(null);
        setRadioVal('link');
        form.setFieldValue('isShowHot', item.isShowHot);
        form.setFieldValue('isShowTab', item.isShowTab);
        setCurrentModule(item);
        // console.log(item);
    };

    // 删除模块
    const deleteModule = (e, item) => {
        setCurrentModule(item);
        Modal.confirm({
            title: '提示',
            content: '删除后，该模块在用户端也一并删除，请确认是否删除？',
            cancelText: '取消',
            okText: '确认',
            closable: true,
            onOk: async () => {
                const res = await moduleDeleteApi({ id: item.id });
                if (res && res.status_code === 200) {
                    message.success('删除成功');
                    getModules();
                    setComponents(getComponent(''));
                }
            },
        });
    };

    // 渲染右侧内容组件
    const getComponent = moduleType => {
        if (moduleType) {
            switch (moduleType) {
                case 'activity':
                    return <ActivitiesComponent />; // 全部活动
                case 'content':
                    return <ContentComponent />; // 精彩内容
                case 'solution':
                    return <SolutionsComponent />; // 解决方案
                case 'member':
                    return; // 项目成员
                case 'info':
                    return <DetailsComponent />; // 项目详情
                case 'training':
                    return <TrainingComponent />; // 培训学习
                case '':
                    return <></>;
                default:
                    return <FreesComponent />; // 自由配置模块
            }
        }
    };

    const dndSensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 10 },
        }),
    );
    const { beginSortDrag, endSortDrag } = useSortDragUserSelectChrome();

    const onDragEnd = useCallback(
        async event => {
            endSortDrag();
            const { active, over } = event;
            if (!over || active.id === over.id) {
                return;
            }
            const oldIndex = menuList.findIndex(item => item.id === active.id);
            const newIndex = menuList.findIndex(item => item.id === over.id);
            if (oldIndex === -1 || newIndex === -1) {
                return;
            }
            const newData = arrayMoveImmutable(menuList, oldIndex, newIndex);
            const ids = newData.map(item => item.id);
            const res = await moduleSortApi([...ids]);
            if (res.status_code === 200) {
                getModules();
            }
        },
        [menuList, endSortDrag],
    );

    const getModules = async () => {
        const res = await moduleListApi({ projectId });
        if (res && res.status_code === 200 && res.data) {
            setMenuList(res.data);

            // 页面刷新 - 渲染对应模块
            if (res.data.length) {
                const currModuleType = res.data.find(item => item.id === id)?.moduleType;
                setComponents(getComponent(currModuleType));
            }
        }
    };

    useEffect(() => {
        getModules();
    }, [projectId]);

    return (
        <>
            <PageHeader title="模块管理" breadcrumb={[{ label: '医项目', path: WORKSPACE_PARENT_PATH }, { label: projectName, path: `${WORKSPACE_ROUTE_BASE}/${projectContextId}` }, '模块管理']} />

            <div className="page-route-body modules-route-body">
                <div className="modules-body">
                    <div className="modules-sider">
                        {!sideCollapsed && (
                            <div className="modules-sider-main">
                                <div className="modules-sider-tree">
                                    <div className="modules-menu-box">
                                        <div className="menu-title">项目模块名称</div>
                                        <DndContext sensors={dndSensors} collisionDetection={closestCenter} onDragStart={beginSortDrag} onDragCancel={endSortDrag} onDragEnd={onDragEnd}>
                                            <SortableContext items={menuList.map(m => m.id)} strategy={verticalListSortingStrategy}>
                                                <div className="modules-menu-list" role="list" aria-label="项目模块列表">
                                                    {menuList.map(item => (
                                                        <SortableModuleRow key={item.id} item={item} activeId={id} changeModules={changeModules} editModule={editModule} deleteModule={deleteModule} />
                                                    ))}
                                                </div>
                                            </SortableContext>
                                        </DndContext>
                                    </div>

                                    {menuList && menuList.length < 10 && (
                                        <div className="menu-item-add">
                                            <Button icon={<i className="bi bi-plus"></i>} onClick={addModule} block>
                                                添加模块
                                            </Button>
                                        </div>
                                    )}
                                </div>

                                <Tooltip title="点击收起">
                                    <button type="button" className="modules-sider-split" onClick={() => setSideCollapsed(true)} aria-label="收起模块列表" />
                                </Tooltip>
                            </div>
                        )}

                        {sideCollapsed && (
                            <Tooltip title="点击展开">
                                <button type="button" className="modules-sider-split modules-sider-split-collapsed" onClick={() => setSideCollapsed(false)} aria-label="展开模块列表" />
                            </Tooltip>
                        )}
                    </div>

                    <div className="modules-content">{components}</div>
                </div>
            </div>

            <Modal title={modalTitle} width={940} className="module-modal" open={isModalOpen} centered onOk={handleOk} onCancel={handleCancel}>
                <Form form={form} name="basic" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} autoComplete="off" initialValues={{ moduleType: 'link' }}>
                    {!menuTitle && <p className="module-tips">说明：项目除了固定的6个模块，最多还可以添加 4 个，由于导航长度有限及导航名称字数不定，添加模块后请预览查看用户端是否超出了有效区域。</p>}

                    <Form.Item
                        label="模块名称"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: '模块名称不能为空',
                            },
                        ]}
                    >
                        <Input placeholder="请输入模块名称" maxLength={20} showCount />
                    </Form.Item>

                    <Form.Item label="是否前台显示HOT标" name="isShowHot" rules={[{ required: true }]}>
                        <Radio.Group onChange={radioHotChange} value={radioHotVal}>
                            <Radio value={1}>显示</Radio>
                            <Radio value={0}>隐藏</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="是否前台显示该模块" name="isShowTab" rules={[{ required: true }]}>
                        <Radio.Group onChange={radioTabChange} value={radioTabVal}>
                            <Radio value={1}>显示</Radio>
                            <Radio value={0}>隐藏</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {!menuTitle && (
                        <>
                            <Form.Item name="moduleType" label="添加类型" rules={[{ required: true }]}>
                                <Radio.Group onChange={radioChange} value={radioVal}>
                                    <Radio value={'link'}>外部链接</Radio>
                                    <Radio value={'rich_text'}>图文模块</Radio>
                                    <Radio value={'time_line'}>时间轴</Radio>
                                </Radio.Group>
                            </Form.Item>

                            {radioVal === 'link' && (
                                <Form.Item
                                    name="url"
                                    label="链接地址"
                                    rules={[
                                        {
                                            required: true,
                                            message: '模块访问路径不能为空',
                                        },
                                    ]}
                                >
                                    <Input placeholder="请输入模块访问路径" />
                                </Form.Item>
                            )}
                            {radioVal === 'rich_text' && (
                                <Form.Item
                                    label="模块内容"
                                    name="content"
                                    rules={[
                                        { required: true },
                                        {
                                            validator: async (rule, editorContents) => {
                                                if (isEffectivelyEmptyRichHtml(editorContents)) {
                                                    throw '请输入模块内容';
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    <TinymceEditor
                                        initEditorValue={initEditorValue}
                                        setEditorContents={setEditorContents}
                                        editorContents={editorContents}
                                        id="editorContents"
                                        placeholder="编辑内容使用的一级标题‘H1’，会在用户端做为目录导航呈现。如需上传图片，建议图片宽度保持1700px，图片两侧不建议留白。"
                                        form={form}
                                        fieldValue="content"
                                    />
                                </Form.Item>
                            )}
                        </>
                    )}
                </Form>
            </Modal>
        </>
    );
}
